module.exports = __webpack_public_path__ + "media/body-condition/cavapoo-chubby-3137b688.svg";